<template>
  <section class="strategic-partners-section">
    <div class="mx-auto w-full max-w-7xl px-4 sm:px-8 lg:px-12 xl:px-[120px] py-8 md:py-9 lg:py-20">
      <!-- Heading -->
      <div class="flex flex-col items-center text-center mb-6 md:mb-8 lg:mb-12">
        <!-- Badge -->
        <span class="font-inter text-xs md:text-sm font-medium leading-5 text-[#36393E] mb-2">
          {{ badge || 'ĐỐI TÁC CHIẾN LƯỢC' }}
        </span>
        <!-- Title -->
        <h2 class="font-display text-base md:text-xl lg:text-2xl font-bold leading-6 md:leading-7 lg:leading-8">
          <span class="bg-gradient-to-r from-[#892DDE] to-[#4A1878] bg-clip-text text-transparent">
            {{ title }}
          </span>
        </h2>
      </div>
      
      <!-- Partners Grid -->
      <div class="grid grid-cols-4 md:grid-cols-8 gap-[10px] md:gap-4 lg:gap-6 xl:gap-8">
        <div
          v-for="(partner, index) in partners"
          :key="index"
          class="strategic-partner-item"
        >
          <img
            v-if="partner.logo"
            :src="partner.logo"
            :alt="partner.name || `Partner ${index + 1}`"
            class="w-full h-full object-contain"
          />
          <div
            v-else
            class="w-full h-full bg-slate-100 rounded-lg flex items-center justify-center"
          >
            <span class="text-slate-400 text-xs">{{ partner.name || `Partner ${index + 1}` }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  content: {
    type: Object,
    default: () => ({}),
  },
});

// Mock data for partners with actual logos
const mockPartners = [
  { name: 'Thanh Pho Ca Phe', logo: '/landing/partner-logo/thanhphocaphe.png' },
  { name: 'The House', logo: '/landing/partner-logo/brand.jpg' },
  { name: 'Xanh Xanh', logo: '/landing/partner-logo/kimkieu.jpg' },
  { name: 'Saigon Trading', logo: '/landing/partner-logo/viettrung.jpg' },
  { name: 'Stafaz', logo: '/landing/partner-logo/stafaz.jpg' },
  { name: 'Xieu Hon', logo: '/landing/partner-logo/xieuhon.png' },
  { name: 'WeroGo', logo: '/landing/partner-logo/malibu.jpg' },
  { name: 'HeroGo', logo: '/landing/partner-logo/herogo.png' },
];

const sectionContent = computed(() => props.content || {});
const badge = computed(() => sectionContent.value.badge || sectionContent.value.label || 'ĐỐI TÁC CHIẾN LƯỢC');
const title = computed(() => sectionContent.value.title || sectionContent.value.headline || 'ĐƯỢC TIN TƯỞNG BỞI NHIỀU DOANH NGHIỆP');
const partners = computed(() => {
  const items = Array.isArray(sectionContent.value.items) 
    ? sectionContent.value.items 
    : Array.isArray(sectionContent.value.partners)
    ? sectionContent.value.partners
    : [];
  const filtered = items.filter(item => item?.logo || item?.name);
  // Use mock data if no real data available
  return filtered.length > 0 ? filtered : mockPartners;
});
</script>

